var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9443 0H1.05566C0.610723 0 0.25 0.343093 0.25 0.766289V5.38318C0.25 5.80638 0.610723 6.14947 1.05566 6.14947H1.86804V19.2339C1.86804 19.657 2.22876 20.0001 2.67371 20.0001H25.3263C25.7712 20.0001 26.132 19.657 26.132 19.2339V6.14947H26.9443C27.3893 6.14947 27.75 5.80638 27.75 5.38318V0.766289C27.75 0.343093 27.3893 0 26.9443 0ZM24.5206 18.4676H3.47937V6.14947H24.5206V18.4676ZM26.1387 4.61689H1.86133V1.53258H26.1387V4.61689Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4988 13.75H15.5012C16.7412 13.75 17.75 12.6285 17.75 11.25C17.75 9.8715 16.7412 8.75 15.5012 8.75H12.4988C11.2588 8.75 10.25 9.8715 10.25 11.25C10.25 12.6285 11.2588 13.75 12.4988 13.75ZM12.4988 10.4121H15.5012C15.9169 10.4121 16.255 10.788 16.255 11.25C16.255 11.7121 15.9169 12.088 15.5012 12.088H12.4988C12.0831 12.088 11.745 11.7121 11.745 11.25C11.745 10.788 12.0831 10.4121 12.4988 10.4121Z",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive_icon.de483a5c.svg";
export { ForwardRef as ReactComponent };